/**
 * Skeleton da página Gerenciar (header + abas + checklist).
 * @module ManageDocumentsReleaseSkeleton
 */

import { memo } from "react";
import { Box, Skeleton, Stack } from "@mui/material";
import { LargeContentBox } from "@/components/common";
import DocumentsChecklistSkeleton from "../components/manage/DocumentsChecklistSkeleton";

export const ManageDocumentsReleaseSkeleton = memo(
  function ManageDocumentsReleaseSkeleton() {
    return (
      <LargeContentBox>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            border: 1,
            borderColor: "grey.200",
            borderRadius: 2,
            overflow: "hidden",
            bgcolor: "background.paper",
            boxSizing: "border-box",
            p: { xs: 1.5, sm: 2 },
            gap: 1.5,
            minHeight: { xs: 520, md: 640 },
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
              borderRadius: 1.5,
              border: 1,
              borderColor: "grey.200",
              bgcolor: "grey.50",
              px: { xs: 1, sm: 1.25 },
              py: 0.75,
            }}
          >
            <Stack direction="row" alignItems="center" spacing={1.5}>
              <Skeleton variant="circular" width={40} height={40} />
              <Stack spacing={0.5} sx={{ flex: 1, minWidth: 0 }}>
                <Skeleton variant="text" width={160} height={16} />
                <Skeleton variant="text" width="45%" height={24} />
              </Stack>
              <Skeleton
                variant="rounded"
                width={168}
                height={40}
                sx={{ borderRadius: 1 }}
              />
            </Stack>
          </Box>

          <Stack direction="row" spacing={2} sx={{ px: 0.5, pb: 1 }}>
            <Skeleton variant="rounded" width={180} height={32} />
            <Skeleton variant="rounded" width={150} height={32} />
          </Stack>

          <Box sx={{ flex: 1, minHeight: 360 }}>
            <DocumentsChecklistSkeleton />
          </Box>
        </Box>
      </LargeContentBox>
    );
  },
);
